import React from 'react';
import { createRoot } from 'react-dom/client';

/*Style Import*/
import 'normalize.css/normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
import './assets/css/global.css';
import './assets/css/style.css';
import './assets/css/responsive.css';

// Make Bootstrap available globally
window.bootstrap = bootstrap;


import App from './App';
import * as serviceWorker from './serviceWorker';
import { initDatadog, identifyDatadogUser } from './datadog';

initDatadog();
identifyDatadogUser();

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// Unregister service worker so deployments are not served from cache (avoids stale UI e.g. missing Download button).
serviceWorker.unregister();
